import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link, Divider } from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import isObject from 'lodash/isObject';
import isNumber from 'lodash/isNumber';
import { ADGMPanel } from 'aurora-components';
import { keyEmptyCheck } from 'aurora-utils/utils';

import styles from './styles';

const ADGMCollapsedPanel = ({
  classes,
  children,
  itemsShowOnViewLess,
  viewMoreText,
  viewLessText,
  dataContainerClassName,
  ...panelProps
}) => {
  if ((!isArray(children) && !isObject(children)) || isEmpty(children)) return null;
  const [isCollapsed, setIsCollapsed] = useState(true);

  const numberOfItemsOnCollapse = useMemo(
    () => (isNumber(itemsShowOnViewLess) && itemsShowOnViewLess > 0 ? itemsShowOnViewLess : 1),
    [itemsShowOnViewLess],
  );

  return (
    <ADGMPanel {...panelProps}>
      <>
        <div className={classNames(classes.dataContainer, dataContainerClassName)}>
          {isArray(children) &&
            (isCollapsed ? children.slice(0, numberOfItemsOnCollapse) : children)?.map((data, index) => (
              <>
                {index > 0 && <Divider className={classes.divider} />}
                {data}
              </>
            ))}
          {!isArray(children) && isObject(children) && children}
        </div>
        {isArray(children) && children?.length > numberOfItemsOnCollapse ? (
          <div className={classNames(classes.viewBtnContainer, classes.btnContainer)}>
            {isCollapsed ? (
              <Link className={classNames(classes.viewBtn, classes?.btn)} onClick={() => setIsCollapsed(false)}>
                {viewMoreText || keyEmptyCheck('view_more')}
                <ExpandMoreIcon />
              </Link>
            ) : (
              <Link className={classNames(classes.viewBtn, classes?.btn)} onClick={() => setIsCollapsed(true)}>
                {viewLessText || keyEmptyCheck('view_less_reasons')}
                <ExpandLessIcon />
              </Link>
            )}
          </div>
        ) : null}
      </>
    </ADGMPanel>
  );
};

ADGMCollapsedPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
  itemsShowOnViewLess: PropTypes.number,
  viewMoreText: PropTypes.array.isRequired,
  viewLessText: PropTypes.array.isRequired,
  dataContainerClassName: PropTypes.string,
  otherProps: PropTypes.object.isRequired,
};

ADGMCollapsedPanel.defaultProps = {
  itemsShowOnViewLess: 1,
  dataContainerClassName: '',
};

export default withStyles(styles)(ADGMCollapsedPanel);
